import { render, staticRenderFns } from "./invigilator.vue?vue&type=template&id=53255146&scoped=true&"
import script from "./invigilator.vue?vue&type=script&lang=js&"
export * from "./invigilator.vue?vue&type=script&lang=js&"
import style0 from "./invigilator.vue?vue&type=style&index=0&id=53255146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53255146",
  null
  
)

export default component.exports